import { FrameContent } from '@design-system';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useTranslation } from 'next-i18next';

import { FF_FRAMING_CONTENT_RELEASE_PAGE } from '../constants/featureFlags';
import type { FramingContentStoryblok } from '../types/generated-storyblok';
import { ContentBlockTitle } from './ContentBlockTitle';

export const ContentBlockFramingContent = ({
  blok,
}: {
  blok: FramingContentStoryblok;
}) => {
  const { t } = useTranslation('framing');
  const enabled = useFeatureIsOn(FF_FRAMING_CONTENT_RELEASE_PAGE);

  if (!enabled) return null;

  return (
    <section className="grid gap-3">
      <ContentBlockTitle
        blok={{
          _uid: blok._uid,
          component: 'title',
          description: blok.description,
          title: blok.title || t('craftsmanship.title'),
          titleSize: blok.titleSize || 'lg',
        }}
        headingClassName="md:tracking-[-0.02em]"
      />
      <FrameContent cta={blok.showStudioCard === false ? null : undefined} />
    </section>
  );
};
